import type { Animation } from "@homeinstead/schemas";

type MotionValues = {
  opacity: number;
  x?: number;
  y?: number;
  scale?: number;
};

type AnimationVariant = {
  initial: MotionValues;
  animate: MotionValues;
};

const ANIMATION_VARIANTS: Record<
  NonNullable<Animation["variant"]>,
  AnimationVariant
> = {
  fade: {
    animate: { opacity: 1 },
    initial: { opacity: 0 },
  },
  "fade-down": {
    animate: { opacity: 1, y: 0 },
    initial: { opacity: 0, y: -32 },
  },
  "fade-left": {
    animate: { opacity: 1, x: 0 },
    initial: { opacity: 0, x: -32 },
  },
  "fade-right": {
    animate: { opacity: 1, x: 0 },
    initial: { opacity: 0, x: 32 },
  },
  "fade-up": {
    animate: { opacity: 1, y: 0 },
    initial: { opacity: 0, y: 32 },
  },
  scale: {
    animate: { opacity: 1, scale: 1 },
    initial: { opacity: 0, scale: 0.9 },
  },
};

const EASE_OUT: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

export { ANIMATION_VARIANTS, EASE_OUT };
